/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.firealarm.rpc.alarms.FireAlarmReadRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type AlarmResponse = {
  createdAt: number;
  revisionNumber?: number;
  id?: number;
  uUID?: OptimizedUUID;
  message: string;
  severity: Severity;
  title: string;
  urlRegexPattern?: string;
  callToAction?: CallToAction;
  debug: Default<boolean>;
  dismissible: Default<boolean>;
  querySelector?: string;
};

export type CallToAction = { url: string; ctaText: Default<string> };

export type OptimizedUUID = { value: string };

export type Severity =
  | 'CRITSIT'
  | 'OUTAGE'
  | 'MAINTENANCE'
  | 'DEBUG'
  | unhandledEnumCase;

export type AlarmReadMobileQueryParams = {
  mobileApp: Default<string>;
  mobileDevicePlatform?: string;
  mobileOsVersion?: string;
  mobileAppVersion?: string;
};

export type FireAlarmReadError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType = 'INVALID_REQUEST' | unhandledEnumCase;

export type GetAlarmsRequest = {
  appName: string;
  languageKey?: string;
  mobileQueryParams?: AlarmReadMobileQueryParams;
};

export type GetAlarmsResponse = { alarms: Default<AlarmResponse[]> };

export type GetAlarmsRequestType = Requestify<GetAlarmsRequest>;
export type GetAlarmsResponseType = GetAlarmsResponse;
export type GetAlarmsErrorType = FireAlarmReadError & HubspotMetadata;
export const getAlarmsRpc: ChirpAvroRpcDetails<
  GetAlarmsRequestType,
  GetAlarmsResponseType,
  GetAlarmsErrorType,
  false
> = {
  serviceName: 'com.hubspot.firealarm.rpc.alarms.FireAlarmReadRpc',
  rpcName: 'getAlarms',
  auth: 'external',
  fingerprint: 'rkkrZ2Xd-CXOGvnFqGsLZobwvblExsZh',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
